// extracted by mini-css-extract-plugin
export default {"recipesTable":"A7KJ70_qUXyCAtsuhu_b"};